import { useState } from "react";
import { fetchAdminRewardProductsAPI, updateAdminRewardBrandAPI, updateAdminRewardProductsAPI } from "./rewardAPI";
import ProductBrowser, { ProductImage, productPrice } from "./ProductBrowser";
import "./Reward.css";

// 관리자 > 기프티콘 상품(2026-10-12). 기프티쇼 전체 상품을 사진과 함께 본다.
// 학원은 전체에서 알아서 고르고, 본사는 '추천'(학원 화면의 한 번에 올리기)과 '숨김'(모든 학원·학생 상점에서 뺌)만 정한다.

const ADMIN_ONLY_OPTION_LIST = [
  { value: "recommended", label: "추천만" },
  { value: "hidden", label: "숨긴 것만" },
];

const formatDateTime = (value) => (value ? new Date(value).toLocaleString("ko-KR") : "아직 없음");

const AdminRewardProductPage = () => {
  const [summary, setSummary] = useState(null);
  const [message, setMessage] = useState("");

  const update = async (product, patch, updateProduct) => {
    try {
      const data = await updateAdminRewardProductsAPI([product.id], patch);
      const saved = data.product_list[0];
      updateProduct({ is_hq_approved: saved.is_hq_approved, is_hq_hidden: saved.is_hq_hidden });
    } catch {
      setMessage("저장하지 못했어요.");
    }
  };

  const updateBrand = async (brandName, patch, reload) => {
    try {
      await updateAdminRewardBrandAPI(brandName, patch);
      reload();
    } catch {
      setMessage("저장하지 못했어요.");
    }
  };

  return (
    <div className="reward-page">
      <div className="reward-card">
        <div className="reward-card__title">
          기프티콘 상품
          <span>
            {summary?.is_mock && <span className="reward-badge reward-badge--mock">예시 상품</span>}{" "}
            <em>
              추천 {summary?.recommended_count ?? 0} · 숨김 {summary?.hidden_count ?? 0}
            </em>
          </span>
        </div>
        <div className="reward-count">기프티쇼 동기화 {formatDateTime(summary?.last_synced_at)}</div>
        {message && <div className="reward-message">{message}</div>}
        <ProductBrowser
          fetchPage={fetchAdminRewardProductsAPI}
          onlyOptionList={ADMIN_ONLY_OPTION_LIST}
          onLoaded={setSummary}
          renderBrandActions={(brand, reload) => (
            <>
              <button type="button" className="reward-button" onClick={() => updateBrand(brand.name, { is_hq_approved: true }, reload)}>
                모두 추천
              </button>
              <button type="button" className="reward-button reward-button--ghost" onClick={() => updateBrand(brand.name, { is_hq_approved: false }, reload)}>
                추천 해제
              </button>
              <button type="button" className="reward-button reward-button--ghost" onClick={() => updateBrand(brand.name, { is_hq_hidden: true }, reload)}>
                모두 숨김
              </button>
              <button type="button" className="reward-button reward-button--ghost" onClick={() => updateBrand(brand.name, { is_hq_hidden: false }, reload)}>
                숨김 해제
              </button>
            </>
          )}
          renderProduct={(product, updateProduct) => (
            <div key={product.id} className="reward-product" data-hidden={product.is_hq_hidden}>
              <ProductImage product={product} />
              <span className="reward-product__brand">{product.brand_name}</span>
              <span className="reward-product__name">{product.goods_name}</span>
              <span className="reward-product__price">{productPrice(product)}</span>
              <span className="reward-product__toggle">
                <button
                  type="button"
                  aria-pressed={product.is_hq_approved}
                  onClick={() => update(product, { is_hq_approved: !product.is_hq_approved }, updateProduct)}
                >
                  추천
                </button>
                <button
                  type="button"
                  className="reward-product__hide"
                  aria-pressed={product.is_hq_hidden}
                  onClick={() => update(product, { is_hq_hidden: !product.is_hq_hidden }, updateProduct)}
                >
                  숨김
                </button>
              </span>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default AdminRewardProductPage;
